<template>
    <div>
        <v-toolbar color="info" dark flat app style="border-bottom:1px solid green" height="50px">

            <v-toolbar-side-icon v-if="hasMenu"
                                 @click.stop="handleDrawerToggle"
            ></v-toolbar-side-icon>
            <img v-if="!hasMenu" src="../../public/home/images/logo.png" class="headerIcon yoprimary"
                 @click="logoClick">
            <!--label class="toolbarTit">{{$store.state.common.title}}</label-->
            <v-toolbar-title class="ml-0 pl-3 hideInMobile" style="line-height: 50px; left: 80px; position: relative">{{$store.state.common.title}}</v-toolbar-title>
<!--            <img-->
<!--                    v-bind:src="computeLogo"-->
<!--                    height="36"-->
<!--                    style="background-color: white;border-radius: 20px;padding: 3px;box-shadow: 1px 1px 1px rgba(0,0,0,0.5)"-->
<!--                    :alt="$t('lang.header.title')"-->
<!--            />-->
<!--            <app-menu/>-->
            <v-spacer></v-spacer>
            <!--
                                <div class="search-text hideInMobile">
                                    <input v-model="search"/>
                                    <v-icon color="#303030" style="float: right">search</v-icon>
                                </div>
            -->
<!--            <lang-switcher class="hideInMobile"></lang-switcher>-->
            <v-btn icon @click="handleFullScreen()" class="hideInMobile">
                <v-icon>fullscreen</v-icon>
            </v-btn>
            <v-menu :close-on-content-click="true"
                    offset-y
                    origin="center center"
                    class="elelvation-1"
                    :nudge-bottom="14"
                    transition="scale-transition"
                    v-model="notify"
            >
                <v-btn icon flat slot="activator">
                    <v-badge color="red" overlap>
                        <span slot="badge" v-if="unreadNotify>0">{{unreadNotify}}
                        </span>
                        <v-icon medium>notifications</v-icon>
                    </v-badge>
                </v-btn>
                <notification-list
                        :items="lstNotify"
                        :count="notifyCount"
                        @activityClicked="handleActivityClicked"
                        @showAllActivity="showAllNotification"
                ></notification-list>
            </v-menu>

            <v-menu
                    offset-y
                    origin="center center"
                    :nudge-bottom="10"
                    transition="scale-transition"
            >
                <v-btn icon large flat slot="activator">
                    <v-avatar size="30px">
                        <!--<v-btn icon>
                          <v-icon color="white">fa fa-user fa-lg</v-icon>
                        </v-btn>-->
                        <!--img :src="$store.state.auth.user.avatar"/-->
                        <i-avatar :user-id="$store.state.auth.user.userId"/>
                        <!--v-icon color="white">fa fa-user fa-lg</v-icon-->
                        <div :style="'font-size: 10px;font-weight: bold;position: absolute;left: 20px;top: 18px;color: #F44336;padding: 0px 5px;color:white;border-radius:5px;background-color:'+backgroundColor()">
                            {{roleName}}
                        </div>
                    </v-avatar>
                </v-btn>
                <v-list class="pa-0">
                    <v-list-tile
                            href="#"
                            @click="handleProfile"
                            ripple="ripple"
                            rel="noopener"
                            key="profile"
                            :to="null"
                            :target="null"
                    >
                        <v-list-tile-action>
                            <v-icon>account_circle</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <!--<v-list-tile-title>{{
                              $t("lang.common.profile")
                            }}</v-list-tile-title>-->
                            <v-list-tile-title>{{
                                this.$store.state.auth.loggedIn? this.$store.state.auth.user.fullName: "Profile"
                                }}
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile
                            href="#"
                            @click="handleLogout"
                            ripple="ripple"
                            rel="noopener"
                            key="logout"
                    >
                        <v-list-tile-action>
                            <v-icon>fullscreen_exit</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>{{
                                $t("lang.auth.logout")
                                }}
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-toolbar>
        <v-navigation-drawer
                class="setting-drawer"
                temporary
                right
                v-model="rightDrawer"
                hide-overlay
                fixed
        >
            <theme-settings></theme-settings>
        </v-navigation-drawer>
    </div>
</template>
<script>
    import {router} from "@/router";
    import axios from "axios";
    import Util from "@/util";
    import LangSwitcher from "./header/LangSwitcher";
    import NotificationList from "@/components/widgets/list/NotificationList";
    import ThemeSettings from "@/components/ThemeSettings";
    import AppMenu from "./AppMenu";
    /*
        var Stomp = require('@stomp/stompjs');
        import SockJS from "sockjs-client";
    */

    export default {
        name: "app-toolbar",
        components: {
            AppMenu,
            LangSwitcher,
            NotificationList,
            ThemeSettings
        },
        props: {
            hasMenu: {
                type: Boolean,
                default: () => {
                    return false;
                }
            }
        },
        data() {
            return {
                notify: false,
                expanded: true,
                rightDrawer: false,
                clickedCard: {
                    sender: "",
                    receiver: ""
                },
                lstNotify: [],
                notifyCount: 0,
                unreadNotify: 0,
                search: "",
                dialog: false
            };
        },
        watch: {
            notify: function (data) {
                //console.log(data);
                if (data == true) {
                    this.unreadNotify = 0;
                }
            },

            search: function (data) {
                //console.log(data);
                this.$store.commit("common/setSearch", data);
                //console.log(this.$store.state.common.search);
            }
        },
        computed: {
            toolbarColor() {
                return this.$vuetify.options.extra.mainNav;
            },
            language() {
                return this.$store.getters.language;
            },
            roleName() {
                if (this.$store.state.auth.user.role == 1) {
                    return "QL";
                }
                // else if (this.$store.state.auth.user.role == 2) {
                //     return "TK";
                // } else if (this.$store.state.auth.user.role == 3) {
                //     return "AM";
                // } else if (this.$store.state.auth.user.role == 4) {
                //     return "KST";
                // } else if (this.$store.state.auth.user.role == 25) {
                //     return "KS";
                // } else if (this.$store.state.auth.user.role == 26) {
                //     return "MH";
                // } 
                else {
                    return "NV";
                }
            },
            computeLogo() {

              const domain = window.location.hostname
              if (domain.includes("lms-edusmart.")) {
                return "/img/logo-edusmart1.png"
              }
              if (domain.includes("localhost")) {
                return "/img/logo-edusmart1.png"
              }
              // default
              return "/img/logo.png"
            },

        },
        methods: {
            backgroundColor() {
                if (this.$store.state.auth.user.role == 1) {
                    return "Crimson";
                } else if (this.$store.state.auth.user.role == 4) {
                    return "blue";
                } else {
                    return "orange";
                }
            },

            openThemeSettings() {
                this.$vuetify.goTo(1);
                this.rightDrawer = !this.rightDrawer;
            },
            handleDrawerToggle() {
                window.getApp.$emit("APP_DRAWER_TOGGLED");
            },
            handleFullScreen() {
                Util.toggleFullScreen();
            },
            handleLogout() {
                this.$store.dispatch("auth/logout", {vm: this});
            },
            handleProfile() {
                console.log(this.$router);
                this.$router.push('/profile');
            },
            handleActivityClicked(e) {
                this.clickedCard = e;
                this.dialog = true;
            },

            showNotify: function () {
                this.unreadNotify = 0;
            },

            getNotify() {
                axios.post(process.env.VUE_APP_API_URL + "/notify/myNotify?page=0&pageSize=10").then(
                    data => {
                        this.lstNotify = data.items;
                        this.notifyCount = data.count;
                        this.unreadNotify = data.unread;
                    },
                    erros => {

                    }
                )
            },

            showAllNotification() {
                axios.post(process.env.VUE_APP_SOCKET_URL + "/notify/myNotify?page=0&pageSize=-1").then(
                    data => {
                        this.lstNotify = data.items;
                        this.notifyCount = data.count;
                        this.unreadNotify = data.unread;
                    },
                    erros => {

                    }
                )
            },

            rechargeMoney: function () {
                this.$router.push(`/payment`);
            },

            toSavedPost: function () {
                this.$router.push(`/savedPost`);
            },

            initWebsocket: function () {
                //console.log("--- init socket ---");
                var url = process.env.VUE_APP_API_URL + "/notification";
                //console.log(url);
                var app = this;
                var socket = new SockJS(url);
                var stompClient = Stomp.over(socket);
                var topic = "/topic/" + this.$store.state.auth.user.userId;
                //console.log(this.$store.state.auth.user.userId);
                //console.log(topic);
                //console.log(stompClient);
                stompClient.connect({}, function (frame) {
                    console.log('Connected: ' + frame);
                    stompClient.subscribe(topic, function (message) {
                        console.log(message.body);
                        app.getNotify();
                    });
                });

            },

            logoClick: function () {
                this.$router.push('/HomePage?time=' + (new Date().getTime()));
            },

            toTeacherAdmin() {
                this.$store.dispatch("auth/updateRole", {role: 1, vm: this});
                //this.$router.push('TeacherPage?time='+(new Date().getTime()));
            },
            toTeacherPage() {
                this.$store.dispatch("auth/updateRole", {role: 4, vm: this});
                //this.$router.push('TeacherPage?time='+(new Date().getTime()));
            },
            toStudentPage() {
                this.$store.dispatch("auth/updateRole", {role: 2, vm: this});
                //this.$router.push('StudentPage?time='+(new Date().getTime()));
            },

            getActive(role) {
                if (this.$store.state.auth.user.role == role) {
                    return "active_profile";
                } else {
                    return "";
                }
            }
        },

        created() {
            if (this.$store.state.auth.loggedIn) {
                //this.$store.dispatch("getUserList");
                //this.$store.dispatch("getNotificationList");
                this.getNotify();
                //this.initWebsocket();
            }
        }
    };
</script>
